/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow

import type { Element } from 'react';

import React from 'react';
import { Link } from 'react-router-dom';

type Props = {|
  value: string,
  row: {
    uuid: string,
    firstName: string,
  },
|};

const LinkCell = (props: Props): Element<typeof Link> => {
  const {
    value,
    row: { uuid },
  } = props;
  return (
    <Link id={uuid} to={uuid}>
      {value}
    </Link>
  );
};

export default LinkCell;
